import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    vendedores: [],
  },
  mutations: {
    carregar(state, lista) {
      state.vendedores = [];
      state.vendedores = lista;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/vendedores?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, data) {
      try {
        let response;
        const dados = {
          ...data,
        };
        const id = dados.id;
        delete dados.id;
        if (data.id === "") {
          response = await securedAxios.post("/vendedores", dados);
        } else {
          response = await securedAxios.put(`/vendedores/${id}`, dados);
        }

        return Promise.resolve(response.data);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    carregar(context, id) {
      return securedAxios.get(`/vendedores/${id}`);
    },
    deletar(context, id) {
      try {
        const response = securedAxios.delete(`/vendedores/${id}`);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
};
